import { render } from "./NewsForCustomersFinal.vue?vue&type=template&id=7433e310"
import script from "./NewsForCustomersFinal.vue?vue&type=script&lang=js"
export * from "./NewsForCustomersFinal.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\Vind\\VindBack\\VindBackVueApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__